
import { CustomerManagementController } from "@/app/ui/controllers/CustomerManagementController";
import { CommodityController } from "@/app/ui/controllers/CommodityController";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { Vue, Options } from "vue-class-component";
import { FlagsPermissionManagementCustomer } from "@/feature-flags/flags-permission-management-customer";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { parsingErrorResponse } from "@/app/infrastructures/misc/Utils";
import { Customer, CustomerSavedPackage } from "@/domain/entities/Customer";
import DataWrapper from "@/app/ui/components/data-wrapper/index.vue";
import SavedPackageRow from "../component/saved-package-row.vue";

@Options({
  components: {
    SavedPackageRow
  }
})
export default class DetailCMSBanner extends Vue {
  dataDetail = new Customer();
  name = "";
  activeTab = "alamat";
  savedPackages: CustomerSavedPackage[] = [];
  isLoadingSavedPackage = false;

  get tabs() {
    return [
      { title: this.$t("managementCustomer.tab.alamat"), value: "alamat" },
      { title: this.$t("managementCustomer.tab.savedPackage"), value: "paket-tersimpan" }
    ];
  }

  onChangeTab(value: string) {
    this.activeTab = value;
    if (value === "paket-tersimpan") {
      this.fetchSavedPackageList();
    }
  }

  async fetchSavedPackageList() {
    this.isLoadingSavedPackage = true;
    try {
      const list = await CustomerManagementController.getSavedPackageList(
        this.id
      );
      this.savedPackages = await Promise.all(
        list.map(async (pkg) => {
          const commodity = await CommodityController.getDetailCommodityByCode(
            pkg.commodityCode
          );
          const localizedCommodityName = AccountController.accountData
            .accountIsForeign
            ? commodity.commodity_name_en || commodity.commodity_name
            : commodity.commodity_name;
          return new CustomerSavedPackage({
            ...pkg,
            commodityName: localizedCommodityName,
            isDangerousGoods: commodity.isDangerousGoods,
            isQuarantine: commodity.isQuarantine
          });
        })
      );
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(error, "Gagal memuat paket tersimpan")
      );
    } finally {
      this.isLoadingSavedPackage = false;
    }
  }

  get isEditAble() {
    return FlagsPermissionManagementCustomer.management_customer_edit.isEnabled();
  }

  goBack() {
    this.$router.push(`/management-customer`);
  }

  mounted() {
    this.fetchDetail();
  }

  get id(): number {
    return Number(this.$route.params.id);
  }

  async fetchDetail() {
    this.dataDetail = await CustomerManagementController.getCustomerDetail(this.id);
    this.name = this.dataDetail.customerName;
  }

  goToEdit() {
    this.$router.push(`/management-customer/edit?id=${this.id}`);
  }

  get openModalDelete() {
    return CustomerManagementController.openModalDelete;
  }

  openDeleteModal() {
    this.setOpenModalDelete(true)
  }

  setOpenModalDelete(open: boolean) {
    CustomerManagementController.setOpenModalDelete(open)
  }

  handlerDelete() {
    this.setOpenModalDelete(false)
    this.onDelete()
  }

  onCloseModalDelete() {
    this.setOpenModalDelete(false)
  }

  async onDelete() {
    MainAppController.showLoading();
    try {
      await CustomerManagementController.deleteCustomer(this.id);
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          error,
          this.$t("managementCustomer.deleteError") as string,
          () => {
            MainAppController.closeErrorMessage();
            this.openDeleteModal();
          }
        )
      );
    } finally {
      MainAppController.closeLoading();
      const customerName = this.name
      this.$router.push(`/management-customer`).then(() => {
        MainAppController.setSnackbarMessage(
          this.$t("managementCustomer.deleteSuccess", {
            name: customerName
          }) as string
        );
        MainAppController.setSnackbarPositivity(false);
        MainAppController.setSnackbar(true);
      });
    }
  }
}
